// src/configs/profiles.js
export const PROFILES = {
  singleCompany: {
    TYPE: 'singleCompany',
    NAME: 'organization',
    NAME_PLURAL: 'organizations',
    REGISTER_ORGANIZATION: 'register_an_organization',
    TITLE_ORGANIZATIONS_TAP: 'organizations',
    NEW_MESSAGE: 'new_organization',
    SELECT_A_COMPANY_PLACEHOLDER: 'select_an_organization',
  },

  // franchising
  multiCompanies: {
    TYPE: 'multiCompanies',
    NAME: 'organization',
    NAME_PLURAL: 'organizations',
    REGISTER_ORGANIZATION: 'register_an_organization',
    TITLE_ORGANIZATIONS_TAP: 'organizations',
    NEW_MESSAGE: 'new_organization',
    SELECT_A_COMPANY_PLACEHOLDER: 'select_an_organization',
  },

  singleClinic: {
    TYPE: 'singleClinic',
    NAME: 'clinic',
    NAME_PLURAL: 'clinics',
    REGISTER_ORGANIZATION: 'register_a_clinic',
    TITLE_ORGANIZATIONS_TAP: 'my_clinic',
    NEW_MESSAGE: 'new_clinic',
    SELECT_A_COMPANY_PLACEHOLDER: 'select_a_clinic',
  },

  MultiClinics: {
    TYPE: 'MultiClinics',
    NAME: 'clinic',
    NAME_PLURAL: 'clinics',
    REGISTER_ORGANIZATION: 'register_a_clinic',
    TITLE_ORGANIZATIONS_TAP: 'my_clinic',
    NEW_MESSAGE: 'new_clinic',
    SELECT_A_COMPANY_PLACEHOLDER: 'select_a_clinic',
  },

  condominium: {
    TYPE: 'condominium',
    NAME: 'condominium',
    NAME_PLURAL: 'condominiums',
    NEW_MESSAGE: 'new_condominium',
    SELECT_A_COMPANY_PLACEHOLDER: 'select_a_condominium',
  },
};
